// extracted by mini-css-extract-plugin
export default {"root":"CustomSnackbar_root__w8SfT"};